import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=c630b388&scoped=true&"
import script from "./businessList.vue?vue&type=script&lang=js&"
export * from "./businessList.vue?vue&type=script&lang=js&"
import style0 from "./businessList.vue?vue&type=style&index=0&id=c630b388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c630b388",
  null
  
)

export default component.exports